import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@shared/ui';

export function SessionsCard() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">{t('settings.sessions.title')}</CardTitle>
        <CardDescription>{t('settings.sessions.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button type="button" variant="outline" disabled title={t('settings.account.comingSoon')}>
          {t('settings.sessions.logoutAll')}
        </Button>
      </CardContent>
    </Card>
  );
}
